/* src/app/order/components/history/change-label/change-label.style.scss */
.change-box {
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
  max-width: 70px;
  min-width: 90px;
  border-radius: 16px;
  text-align: center;
  font-size: 10px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  line-height: 1.6;
  height: 16px;
  letter-spacing: 0.55px;
  width: 100%;
  display: inline-block;
}
.change-box.client {
  color: #ffffff;
  background-color: #ee7f00;
}
.change-box.application-reviewer {
  color: #ffffff;
  background-color: #d7273d;
  max-width: 160px;
  min-width: 160px;
}
.change-box.client-service {
  color: #ffffff;
  background-color: #d7273d;
  max-width: 70px;
  min-width: 70px;
}
/*# sourceMappingURL=change-label.style.css.map */
